<template>
  <div id="landing4" v-observe-visibility="{
    callback: visibilityChanged,
    once: true,
  }" >
    <v-layout column wrap align-center justify-center>
      <v-flex>
        <transition name="fadeintro">
          <div v-if="showIntro" class="landing4-box">
            <h2 class="white--text">Surveys by Unmanned Aerial Vehicles</h2>
            <p>UAVs can speed up many traditional surveys. ThinkSpatial performs volume and stockpile extraction for many quarries accross Victoria.</p>
            <v-btn class="mx-2" fab small color="green" v-on:click="animateMap">
              <v-icon dark>play_arrow</v-icon>
            </v-btn>          
          </div>
        </transition>
        <transition name="fadeintro">
          <div v-if="!showIntro" class="landing4-box small-box">
            <v-btn class="mx-2" fab small color="green" v-on:click="animateMap">
              <v-icon dark>pause</v-icon>
            </v-btn>          
          </div>
        </transition>        
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import PublicLandingApi from '@/services/PublicLandingApi';
import Mapbox from 'mapbox-gl'
export default {
  data () {
    return {
      showIntro: true,
      animationId: null,
      quarryId: 0,
      data: null,
      landing4: null,
      token: 'pk.eyJ1IjoiYWdhdXNzZW4iLCJhIjoiY2oydXp1dmg0MDAxeDJ2azJjOTM1Y202MCJ9.snYgaaG8eVpXPGw120O5Pg',
    }
  },
  methods: {
    intervalRorateUav() {
      return window.setInterval(()=> {
          this.landing4.setPaintProperty('quarry'+this.quarryId, 'raster-opacity', 0);
          this.quarryId = this.quarryId+1;
          if (this.quarryId > 5) {
            this.quarryId = 0;
          } 
          this.landing4.setPaintProperty('quarry'+this.quarryId, 'raster-opacity', 1);
        }, 4000 );
    },  
    animateMap(){
      this.showIntro = !this.showIntro
      if(!this.showIntro) {
        this.animationId = this.intervalRorateUav();
      } else {
        setTimeout(()=>{
          window.clearInterval(this.animationId);
          this.animationId = null;
        },0);
      }
    },
    visibilityChanged(){
      console.log('Resize landing4')
      this.landing4.resize();
    },
    async getFeatures() {
      const response = await PublicLandingApi.heros('quarry')
      for(let [index, quarry] of JSON.parse(response.data.data).entries()){
        this.landing4.addLayer({
          'id': 'quarry' + index,
          'source': {
            'type': 'image',
            'url': require( 'assets/img/uav/' + quarry.file+''),
            'coordinates': quarry.coordinates
          },
          'type': 'raster',
          'paint': {
            'raster-opacity': 0,
            'raster-opacity-transition': {
                'duration': 2500
            }
          }
        });
      }
      this.landing4.setPaintProperty('quarry0', 'raster-opacity', 1);
    }   
  },
  mounted(){
    this.$nextTick(function () {
      Mapbox.accessToken = this.token
      let map = new Mapbox.Map({
        container: 'landing4',
        style: 'mapbox://styles/mapbox/satellite-v9',
        pitch: 0,
        center: [144.527123, -37.901451],
        zoom: 16,
        interactive: false
      });
      this.landing4 = map;
      map.on('load', ()=> {
        this.getFeatures()
      })      
    })
  }
}
</script>

<style>
  #landing4 {
    height: 100%;
    width: 100%;
  }

  .fadeintro-enter-active, .fadeintro-leave-active {
    transition: opacity .5s;
  }

  .fadeintro-enter, .fadeintro-leave-to {
    opacity: 0;
  }

  .landing4-box {
    position: absolute;
    left: 10%;
    bottom: 60px;
    z-index: 5;
    background-color: #f1592a;
    padding: 5px;
    text-align: center;
    line-height: 30px;
    padding-left: 10px;
    max-width: 250px;
  }

  .small-box {
    padding: 5px;
    border-radius: 35px;
  }

  .landing4-box p {
    color: #fff;
    box-sizing: border-box;
    line-height: 18px;
  }    
</style>